<template>
  <button
      type="button"
      class="btn-nulled p-0"
      data-bs-html="true"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      :title="title"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    title: HTMLElement
  }
}
</script>
